import React, {useEffect} from "react";

// types
import { Order } from "../../../../types/orders/order";
import { DateRange } from "../../../../types/common";

// components
import OrdersContent from "./Orders.content";
import RejectedView from "./RejectedView";
import { useClassicView } from "../../../../config/classicView";
import {dateToShortDateString, getDefaultDates, setCurrentTab} from "../../../../utils/functions";

interface Props {
  orders: Order[];
  fetchingOrders: boolean;
  getOrdersRequest: (data: any, params: any) => Promise<void>;
  // filters
  rangeDate: DateRange;
  activeFilters: any;
  sendFilters: () => void;
  take: number;
  skip: number;
  total: number;
  featuresAllowed: string[];
}

export default (props: Props) => {
  const dateSince = dateToShortDateString(props.rangeDate.start) || getDefaultDates().start;
  const dateUntil = dateToShortDateString(props.rangeDate.end) || getDefaultDates().end;

  useEffect(() => {
    setCurrentTab('rejected_orders');

    const dataQuery = {
      filter: props.activeFilters.filter,
      skip: props.skip,
      take: props.take,
    };

    const params = {
      dateSince, dateUntil
    };
    props.getOrdersRequest(dataQuery, params);
  }, []);

  const { classic } = useClassicView();
  const Content = classic ? OrdersContent : RejectedView;

  return (
      <Content
          tableData={props.orders}
          fetchingOrders={props.fetchingOrders}
          sendFilters={props.sendFilters}
          take={props.take}
          skip={props.skip}
          total={props.total}
          activeFilters={props.activeFilters}
          featuresAllowed={props.featuresAllowed}
      />
  );
};
